import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=13123f7a&"
import script from "./debug.vue?vue&type=script&lang=js&"
export * from "./debug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports